import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import DeleteModal from "../../components/Modals/DeleteModal";
import AllSubscriptionsModal from "../../components/Modals/AllSubscriptionsModal";
import "./user.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack, Delete, Visibility, Add, KeyboardArrowDown } from "@material-ui/icons";
import {
  fetchUsers,
  fetchUserSubscriptions,
  deleteUserAction,
  createUserSubscriptionAction,
  fetchSubscriptionsType,
} from "../../redux/actions/userMainActions";

const initialState = {
  userId: "",
  subscriptionType: "",
  startTime: "",
  timesAllowed: 0,
};

export default function User(props) {
  let history = useHistory();
  const { userId } = useParams();

  const dispatch = useDispatch();
  const { users, userSubscriptions, subscriptionsType, loading, subscriptionAssignedMessage } = useSelector(
    (state) => state.user
  );

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [isVisible, setIsVisible] = useState(false);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [subscriptionDate, setSubscriptionDate] = useState("");
  const [subTypeData, setSubTypeData] = useState(null);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleFormChange("userId", userId);
    dispatch(fetchUsers());
    dispatch(fetchUserSubscriptions(userId));
    dispatch(fetchSubscriptionsType());
  }, [dispatch, userId]);

  const handleSelectSubsType = (val) => {
    setSubTypeData(val);
    handleFormChange("subscriptionType", val._id);
    setSubscriptionModal(false);
  };

  const handleCreate = () => {
    const formattedDate = subscriptionDate ? new Date(subscriptionDate).getTime() : null;
    dispatch(createUserSubscriptionAction({ ...initialStateForm, startTime: formattedDate }));
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const handleDelete = () => {
    dispatch(deleteUserAction(userId));
    setOpenDeleteModal(true);
  };

  const ref = useRef();

  const particularUserData = users.find((user) => user._id === userId);

  return (
    <div className="user">
      {openDeleteModal && <DeleteModal closeModal={() => setOpenDeleteModal(false)} children="User Deleted Successfully" />}

      <div className="userHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTitle">User Details</h1>
        </div>
        <img className="userLogo" src={logoBlue} alt="logo" width="150px"></img>
      </div>

      <div className="userDetailsView">
        <div className="userDetailsViewR1">
          <div className="userDetailsUserName">
            <span>User Name:</span> {particularUserData?.userName}
          </div>
          <button className="deleteUserBtn" onClick={handleDelete}>
            <Delete className="deleteBtnIcon" />
          </button>
        </div>
        <div className="userDetailsViewR2">
          <div className="userDetailsUserEmail">
            <span>Email Address:</span> {particularUserData?.email}
          </div>
          <div className="userDetailsUserContact">
            <span>Contact:</span> {particularUserData?.contactNumber}
          </div>
        </div>
        <div className="userDetailsViewR3">
          <div className="userDetailsUserSubscription">
            <span>User Subscriptions:</span>
            {userSubscriptions &&
              userSubscriptions.map((v, i) => (
                <div className="subRow" key={v._id}>
                  <div className="subTxt">
                    {v.subscriptionType.subscriptionName === "Free trial(Clock stats)"
                      ? "Free Trial"
                      : v.subscriptionType.subscriptionName === "Free trial(Clock only)"
                      ? "Free Trial"
                      : v.subscriptionType.subscriptionName === "times allowed(stats)"
                      ? "Usage Times"
                      : v.subscriptionType.subscriptionName === "times allowed(only)"
                      ? "Usage Times"
                      : v.subscriptionType.subscriptionName}{" "}
                    ({v.subscriptionType.type === "clock with stats" ? "stats clock" : "only clock"})
                  </div>
                  <Link to={"/UserSubscriptionDetails/" + v._id}>
                    <button className="subDetailsBtn">
                      <Visibility className="subDetailsBtnIcon" />
                    </button>
                  </Link>
                </div>
              ))}
          </div>
        </div>
        <div className="userDetailsViewR4">
          <div className="addSubTxt">{subscriptionAssignedMessage}</div>
          <button onClick={handleOpen} className="addSubIcon">
            <Add className="addSubIconIcon"></Add>
          </button>
          <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box className="muiUserSubModalStyle">
              <text className="userSubModalHeading">ADD A SUBSCRIPTION</text>
              <div>
                <div className="userSubModalInputRow">
                  <div className="userSubModalInputRowInner">
                    <text className="userSubModalLabel">Subscription Type</text>
                    <button className="ddButton">
                      <AllSubscriptionsModal
                        data={subscriptionsType}
                        setSubTypeData={handleSelectSubsType}
                        subscriptionModal={subscriptionModal}
                        onBackdropPress={() => setSubscriptionModal(false)}
                      />
                    </button>
                  </div>
                  <input className="userSubModalInput" value={subTypeData?.subscriptionName || ""}
                   disabled />
                </div>

                {subTypeData?.subscriptionName === "times allowed(stats)" && (
                  <div className="userSubModalInputRow">
                    <div>
                      <text className="userSubModalLabel">No. of uses</text>
                      <input
                        className="userSubModalInput"
                        placeholder="number of uses"
                        defaultValue={initialStateForm?.timesAllowed}
                        onChange={(e) => handleFormChange("timesAllowed", parseInt(e.target.value))}
                      />
                    </div>
                  </div>
                )}
                {subscriptionsType?.subscriptionName === "times allowed(only)" && (
                  <div className="userSubModalInputRow">
                    <div>
                      <text className="userSubModalLabel">Usage times</text>
                      <input
                        className="userSubModalInput"
                        placeholder="number of uses"
                        defaultValue={initialStateForm?.timesAllowed}
                        onChange={(e) => handleFormChange("timesAllowed", parseInt(e.target.value))}
                      />
                    </div>
                  </div>
                )}
                <div className="userSubModalInputRow">
                  <div>
                    <text className="userSubModalLabel">Subscription date (MM/DD/YYYY)</text>
                    <input
                      className="userSubModalInput2"
                      placeholder="select subscription date"
                      value={subscriptionDate}
                      onFocus={() => {
                        const today = new Date();
                        const formattedToday = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
                        setSubscriptionDate(formattedToday);
                      }}
                      onChange={(e) => setSubscriptionDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <button className="addSubModalButton" onClick={handleCreate}>
                Add
              </button>
            </Box>
          </Modal>
        </div>
        <div className="userDetailsViewR5">
          <Link to={"/editUser/" + userId}>
            <button className="editUserBtn">Edit</button>
          </Link>
          <Link to={"/UserTeams/" + userId}>
            <button className="editUserBtn">View Teams</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
